const messages = [
    "Learning is a never-ending journey 🚀",
    "Keep coding, keep growing 📈",
    "Every line of code is a new opportunity 💻",
    "The best way to predict the future is to create it 🔮",
    "The value of a personal portfolio is built over time ⌚",
    ];

export default messages;
